import { useState, useEffect, useMemo } from 'react';
import { Column } from 'react-table';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { Button, Card, Col, Row } from 'react-bootstrap';
import { columnsData } from '../columnsListPud';
import VehicleTableContainer from '../../VehicleTable/VehicleTableContainer';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
import toaster from '../../../utils/toaster';

import ModalPud from '../ModalCreatePud/ModalsPud';
import { useApiClient } from '../../../hooks/useApiClient';
import useTiassistoStore from '../../../store/TiassistoStore';
import _ from 'lodash';
import TiassistoElement from '../TiassistoElement';
import { DriveItEasyStatusEnum } from '../../../api/models/Enums';

interface OpenModals {
  createPud: boolean;
  detailsPud: boolean;
}

interface TiassistoPudListProps {
  licensePlate: string;
  driveItEasyStatus?: string;
}

const TiassistoPudList = ({ driveItEasyStatus, licensePlate }: TiassistoPudListProps) => {
  const [openModal, setOpenModal] = useState<OpenModals>({ createPud: false, detailsPud: false });
  const { t } = useTranslation()
  const { apiClient, handleApi } = useApiClient();
  const { vehicle, setPudId, pudId, setPudDetails, pudDetails } = useTiassistoStore();
  const filterIntialState = {
    status_description: [],
  }

  const { data: activePudList, isLoading: activePudLoading, error: activePudError } = useQuery({
    queryKey: ['activePudList'],
    // queryKey: ['activePudList', licensePlate],
    queryFn: () => apiClient.tiassistoController.getActivePud(licensePlate),
    enabled: !!licensePlate,
    // staleTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
    // retry: false,
  });

  const { data: responsePudDetails, isLoading: pudListsLoading, error: pudListError, status } = useQuery({
    queryKey: ['singlePud'],
    queryFn: () => apiClient.tiassistoController.getPudDetails(pudId),
    enabled: !!pudId,
    // staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const handleDoubleClick = (row) => {
    setOpenModal((prev) => ({ ...prev, detailsPud: true }));
    setPudId(row?.original?.id);
  };

  useEffect(() => {
    if (status === 'success' && responsePudDetails) {
      setPudDetails(responsePudDetails);
    }
  }, [status, responsePudDetails, setPudDetails]);

  useEffect(() => {
    if (status === 'error' && pudListError) {
      console.error('Error fetching data: ', pudListError);
      toaster.error(i18next.t("error_fetching_pud_details"));
    }
  }, [status, pudListError]);

  const columns = useMemo(() => columnsData as Column<Object>[], []);
  const data = useMemo(() => activePudList?.activePudList ?? [], [activePudList]);

  return (
    <TiassistoElement>
      <div className="mb-4">
        <Row>
          <Col md={6} className="display-6">
            {t("pud_procedures")}
          </Col>
          <Col md={6} className="text-end">
            <Button
              onClick={() => setOpenModal((prev) => ({ ...prev, createPud: true }))}
              disabled={driveItEasyStatus === DriveItEasyStatusEnum.SOSPESO}
            >
              {t("create_new_pud")}
            </Button>
            <div className="mt-2" style={{ fontSize: '18px' }}>
              <small>{t('status_drive_it_easy')}: <span className='fw-bold'>{driveItEasyStatus}</span></small>
            </div>
          </Col>
        </Row>
        {_.isEmpty(activePudList) && (
          <Card className='mt-3'>
            <Card.Body>
              {t("no_active_pud_available")}
            </Card.Body>
          </Card>
        )}

        {!_.isEmpty(activePudList) && (
          <ErrorBoundary>
            <VehicleTableContainer
              columns={columns}
              data={data}
              handleDoubleClick={handleDoubleClick}
              loading={false}
              error={activePudError}
              filterIntialState={filterIntialState}
            ></VehicleTableContainer>
          </ErrorBoundary>
        )}

        {/* Modal Crate PUD */}
        <ModalPud
          isOpen={openModal.createPud}
          onClose={() => setOpenModal((prev) => ({ ...prev, createPud: false }))}
          mode={"create_new_pud"}
          licensePlate={licensePlate}
        />

        {/* Modal Details PUD */}
        <ModalPud
          isOpen={openModal.detailsPud}
          onClose={() => setOpenModal((prev) => ({ ...prev, detailsPud: false }))}
          mode={"details_pud"}
          licensePlate={licensePlate}
        />

      </div>
    </TiassistoElement>
  )
}

export default TiassistoPudList
